// For use with raw string arrays — values that are NOT backed by DB records and
// have no server-side IDs (e.g., plain string arrays from external API responses).
// Selected items are exposed via this.select.items as an array of strings.
//
// Values:
//   selected    (Array, default: [])      - Pre-selected string values
//   placeholder (String)                  - Input placeholder text
//   allowCreate (Boolean, default: true)  - Allow free-form entry of new values
//   maxItems    (Number, default: 0)      - Max selectable items; 0 = unlimited
//   persist     (Boolean, default: false) - Keep created options in dropdown after removal
//   delimiter   (String, default: ",")    - Character used to split pasted input

import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    selected:    { type: Array,   default: [] },
    placeholder: { type: String,  default: "Type and press Enter to add..." },
    allowCreate: { type: Boolean, default: true },
    maxItems:    { type: Number,  default: 0 },
    persist:     { type: Boolean, default: false },
    delimiter:   { type: String,  default: "," },
  }
  static targets = ["select"]

  connect() {
    this.initializeTomSelect()
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
    }
  }

  initializeTomSelect() {
    if (!this.element) return

    this.select = new TomSelect(this.selectTarget, {
      plugins: {
        remove_button: {
          label: '<i class="far fa-times-circle" aria-hidden="true"></i>',
          title: 'Remove',
        },
      },
      valueField: 'name',
      labelField: 'name',
      searchField: ['name'],
      create: this.allowCreateValue,
      load: null,
      preload: false,
      maxItems: this.maxItemsValue === 0 ? null : this.maxItemsValue,
      persist: this.persistValue,
      delimiter: this.delimiterValue,
      placeholder: this.placeholderValue,
      items: this.selectedValue,
      options: this.selectedValue.map(name => ({ name })),
      onItemAdd: () => {
        this.select.setTextboxValue('')
      },
    })
  }
}
